module.exports = __webpack_public_path__ + "static/media/Casino.f909a7b3.svg";